import { FC } from 'react';
import { useEffect } from 'react';
import Script from 'next/script';
import $ from 'jquery';
import { BOOK_WIDGET_LFROM } from '@/helpers/variables';

interface ILitresWidget {
  bookTitle: string;
  authorName: string;
}

const LitresWidget: FC<ILitresWidget> = ({ bookTitle, authorName }) => {
  let fix = true;
  useEffect(() => {
    fix = !fix;
    if (fix) return;
    <Script src="//www.litres.ru/static/widgets/buy_widget/js/widget.js" strategy="lazyOnload" />;

    $.get(
      'https://www.litres.ru/ref_widget_art_alltypes/',
      {
        q: bookTitle,
        q_author: authorName,
        lfrom: BOOK_WIDGET_LFROM,
      },
      function (data: any) {
        $('#widget').append(data);
      }
    );
  }, []);

  return <div id="widget"></div>;
};

export default LitresWidget;
